<template>
  <div
    v-click-outside="$_popupClose"
    class="ll-download-icon"
    :class="{primary:primary,noPadding:noPadding}"
    @click.stop="onclick()"
  >
    <div class="ll-download-icon_content">
      <i
        v-if="leadingIcon"
        :class="leadingIcon"
        class="ll-download-icon_icon"
      />
      <img
        v-if="leadingImage"
        :src="leadingImage"
        alt=""
        class="ll-download-icon_image"
      >
      <p class="ll-download-icon_text">
        <slot /> <span v-if="num">({{ num }})</span>
      </p>
      <i
        v-if="trailingIcon"
        :class="trailingIcon"
        class="ll-download-icon_icon after"
      />
    </div>
    <div
      class="ll-download-icon_popup-menu"
      :class="{'popup-active':popupActive}"
    >
      <div
        v-for="(btnItem, btnIndex) in btnList"
        :key="btnIndex"
        class="ll-download-icon_popup-menu-item"
        :class="{disabled:btnItem.disabled}"
        @click.stop="btnClick(btnItem)"
      >
        <p>{{ btnItem.text }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import ClickOutside from "vue-click-outside";
export default {
  name: "LlIconWithPopupMenu",

  directives: {
    ClickOutside,
  },

  props: {
    primary: {
      type: Boolean,
      default: false,
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    trailingIcon: {
      type: String,
      default: "",
    },
    num: {
      type: Number,
      default: 0,
    },
    leadingImage: {
      type: String,
      default: "",
    },
    bold: {
      type: Boolean,
      default: false,
    },
    btnList: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data: () => ({
    popupActive: false,
  }),
  methods: {
    onclick() {
      this.popupActive = true;
      this.$emit("click");
    },
    $_popupClose() {
      this.popupActive = false;
    },
    btnClick(btnItem) {
      if (btnItem.disabled) return;
      this.$emit("btn-click", btnItem);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-icon-with-popup-menu";
</style>